import * as tslib_1 from "tslib";
import { HttpHeaders } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpHelper } from "src/app/shared/class/HttpHelper";
import { Helper } from "src/app/shared/helpers/helper";
import { BASE_BACKEND, BASE_UMOVME, ENDPOINT, } from "src/app/shared/http/api";
import { globalConst } from "./../../shared/helpers/constants";
export class ServiceRequestService {
    constructor(http, authService) {
        this.http = http;
        this.authService = authService;
        this.httpHelper = new HttpHelper();
    }
    getServiceLocals() {
        return this.http
            .get(`${BASE_BACKEND}${ENDPOINT.serviceLocal.list}`)
            .toPromise()
            .then((data) => data)
            .catch((error) => error);
    }
    getCompanies() {
        return this.http
            .get(`${BASE_BACKEND}${ENDPOINT.company.list}`)
            .toPromise()
            .then((data) => data)
            .catch((error) => error);
    }
    getRegionals() {
        return this.http
            .get(`${BASE_BACKEND}${ENDPOINT.regional.list}`)
            .toPromise()
            .then((data) => data)
            .catch((error) => error);
    }
    getAgents() {
        return this.http
            .get(`${BASE_BACKEND}${ENDPOINT.agent.list}`)
            .toPromise()
            .then((data) => data)
            .catch((error) => error);
    }
    getSchedules(queryParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const params = this.authService.getUserLogged().type !== globalConst.defaults.user.admin
                ? `${queryParams || ""}&userId=${this.authService.getUserLogged().id}`
                : queryParams || "";
            return this.http
                .get(`${BASE_BACKEND}${ENDPOINT.schedule.list}/all?${params}`)
                .toPromise()
                .then((data) => data)
                .catch((error) => error);
        });
    }
    listSchedules(filters) {
        return this.http
            .get(`${BASE_BACKEND}${ENDPOINT.schedule.list}${this.httpHelper.getQueryParams(filters, true)}`)
            .pipe(catchError(Helper.handleError));
    }
    getSchedule(scheduleId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.http
                .get(`${BASE_BACKEND}${ENDPOINT.schedule.get}/${scheduleId}`)
                .toPromise()
                .then((data) => data)
                .catch((error) => error);
        });
    }
    updateSchedule(scheduleId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.http
                .put(`${BASE_BACKEND}${ENDPOINT.schedule.update}`, { scheduleId })
                .toPromise()
                .then((data) => data)
                .catch((error) => error);
        });
    }
    /*
    async insertSchedule(schedule: any): Promise<ServiceRequest> {
      return this.http
        .post(`${BASE_BACKEND}${ENDPOINT.schedule.insert}`, schedule)
        .toPromise()
        .then((data) => data)
        .catch((error) => error);
    } */
    associateSchedule(scheduleId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const userId = this.authService.getUserLogged().id;
            return this.http
                .post(`${BASE_BACKEND}${ENDPOINT.schedule.associate}`, {
                userId,
                scheduleId,
            })
                .toPromise()
                .then((data) => data)
                .catch((error) => error);
        });
    }
    createSchedule(serviceRequest) {
        return this.http
            .post(`${BASE_BACKEND}${ENDPOINT.schedule.create}`, Object.assign({}, serviceRequest))
            .pipe(map((data) => data), catchError((error) => {
            return throwError(error);
        }));
    }
    updateServiceRequestAgent(agentId, serviceRequestId) {
        const httpOptions = {
            headers: new HttpHeaders({
                "Content-Type": "application/x-www-form-urlencoded",
            }),
        };
        const postedData = `data=<schedule>
    <agent>
         <id>${agentId}</id>
      </agent>
    </schedule>`;
        return this.http
            .post(`${BASE_UMOVME}${ENDPOINT.umovme.schedule}/${serviceRequestId}.xml`, postedData, httpOptions)
            .pipe(map((xmlString) => {
            return this.xmlStringToJson(xmlString);
        }), catchError((error) => {
            return throwError(error);
        }));
    }
    verifyOpening(serviceLocalId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.http
                .get(`${BASE_BACKEND}${ENDPOINT.schedule.verifyOpening}/${serviceLocalId}`)
                .toPromise()
                .then((data) => data)
                .catch((error) => error);
        });
    }
    sendScheduleEmail(scheduleId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.http
                .get(`${BASE_BACKEND}${ENDPOINT.schedule.sendScheduleEmail}/${scheduleId}`)
                .toPromise()
                .then((data) => data)
                .catch((error) => error);
        });
    }
    sendAgentEmail(agentId, scheduleId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.http
                .get(`${BASE_BACKEND}${ENDPOINT.schedule.sendAgentEmail}/${agentId}/${scheduleId}`)
                .toPromise()
                .then((data) => data)
                .catch((error) => error);
        });
    }
    xmlStringToJson(xml) {
        // Convert the XML string to an XML Document.
        const oParser = new DOMParser();
        const oDOM = oParser.parseFromString(xml, "application/xml");
        // Convert the XML Document to a JSON Object.
        return this.xmlToJson(oDOM);
    }
    xmlToJson(xml) {
        // Create the return object
        let obj = {};
        if (xml.nodeType === 1) {
            // element
            // do attributes
            if (xml.attributes.length > 0) {
                obj["@attributes"] = {};
                for (let j = 0; j < xml.attributes.length; j++) {
                    const attribute = xml.attributes.item(j);
                    obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
                }
            }
        }
        else if (xml.nodeType === 3) {
            // text
            obj = xml.nodeValue;
        }
        // do children
        if (xml.hasChildNodes()) {
            for (let i = 0; i < xml.childNodes.length; i++) {
                const item = xml.childNodes.item(i);
                const nodeName = item.nodeName;
                if (typeof obj[nodeName] === "undefined") {
                    obj[nodeName] = this.xmlToJson(item);
                }
                else {
                    if (typeof obj[nodeName].push === "undefined") {
                        const old = obj[nodeName];
                        obj[nodeName] = [];
                        obj[nodeName].push(old);
                    }
                    obj[nodeName].push(this.xmlToJson(item));
                }
            }
        }
        return obj;
    }
}
